module.exports = __webpack_public_path__ + "img/JA_Circle-Black_small.98ed3050.png";